// 获取注册内容弹窗组件
export function getfreshgraduateDialogData() {
    return [
        {
            key: "stuNum",
            name: "考生号",
            value: '',
            type: 'input',
            isNull: false,
            writeOrRead: 'write'
        },
        {
            key: "name",
            name: "姓名",
            value: '',
            type: 'input',
            isNull: false,
            writeOrRead: 'write'
        }, {
            key: "sex",
            name: "性别",
            value: '男',
            type: 'radio',
            isNull: false,
            options: [{ label: "男" }, { label: "女" }],
            writeOrRead: 'write'
        }, {
            key: "studyType",
            name: "科类",
            value: '文科',
            type: 'radio',
            isNull: false,
            options: [{ label: "文科" }, { label: "理科" }],
            writeOrRead: 'write'
        }, {
            key: "idCard",
            name: "身份证号",
            value: '',
            type: 'input',
            isNull: false,
            writeOrRead: 'write'
        }, {
            key: "portfolioCategory",
            name: "投档段类",
            value: 'A',
            type: 'radio',
            isNull: false,
            options: [{ label: "A" }, { label: "B" }],
            writeOrRead: 'write'
        }, {
            key: "readyProfession",
            name: "考试志愿",
            value: '',
            type: 'select',
            isNull: false,
            // prompt: "(注:需填写学校全称)",
            writeOrRead: 'write',
            options: []
        }, {
            key: "volunteerType",
            name: "志愿类别",
            value: '普通',
            type: 'select',
            isNull: false,
            // prompt: "(注:需填写学校全称)",
            writeOrRead: 'write',
            options: [
                { label: "非免试退役士兵", value: "非免试退役士兵" },
                { label: "建档立卡", value: "建档立卡" },
                { label: "免试退役士兵", value: "免试退役士兵" },
                { label: "三等功鼓励政策退役士兵", value: "三等功鼓励政策退役士兵" },
                { label: "技能大赛鼓励政策", value: "技能大赛鼓励政策" },
                { label: "普通", value: "普通" },
            ]

        }, {
            key: "school",
            name: "毕业院校",
            value: '',
            type: 'input',
            isNull: false,
            // prompt: "(注:需填写学校全称)",
            writeOrRead: 'write'

        }, {
            key: "profession",
            name: "毕业专业",
            value: '',
            type: 'input',
            isNull: false,
            // prompt: "(注:需填写专业全称)",
            writeOrRead: 'write'

        },
        {
            key: "phone",
            name: "联系电话",
            value: '',
            type: 'input',
            isNull: false,
            writeOrRead: 'write'

        },
        {
            key: "contact",
            name: "紧急联系人",
            value: '',
            type: 'input',
            isNull: false,
            writeOrRead: 'write'

        }, {
            key: "address",
            name: "家庭住址",
            value: '',
            type: 'input',
            isNull: false,
            writeOrRead: 'write'

        },
        {
            key: "proveFile",
            name: "报名材料",
            fileName: '',
            uploadTitle: "报名材料",
            type: 'uploadImg3',
            imgFlag: '',
            isNull: false,
            prompt: "(注:仅支持图片及pdf格式)",
            value: [
            ],
            fujianload: '附件下载',
            url: "", // 附件url
            fujianName: "",
            writeOrRead: 'write'

        },
        //  {
        //     key: "statusCheckFile",
        //     name: "学籍资料审核表",
        //     fileName: '',
        //     uploadTitle: "学籍资料审核表",
        //     type: 'uploadImg2',
        //     imgFlag: '',
        //     isNull: false,
        //     prompt: "(注:须加盖公章后上传)",
        //     value: [
        //     ],
        //     fujianload: '附件下载',
        //     url: "", // 附件url
        //     fujianName: "",
        //     writeOrRead: 'write'

        // },
        // {
        //     key: "withoutTestFile",
        //     name: "加分(免试)",
        //     fileName: '',
        //     uploadTitle: "加分(免试)",
        //     type: 'uploadImg3',
        //     isNull: true,
        //     // isTip: "指南",
        //     fujianload: '点击下载 :',
        //     url: "", // 附件url
        //     value: [],
        //     fujianName: "",
        //     nameflag: false,
        //     writeOrRead: 'write',
        //     prompt:"（最多上传两张）"

        // }, 
        // {

        //     key: "proveFile",
        //     name: "证明材料复印件",
        //     fileName: '',
        //     uploadTitle: "证明材料复印件",
        //     type: 'uploadImg3',
        //     isNull: false,
        //     // isTip: "指南",
        //     fujianload: '点击下载 :',
        //     url: "", // 附件url
        //     value: [],
        //     fujianName: "",
        //     nameflag: false,
        //     writeOrRead: 'write',
        //     prompt:"（注：按照2025年合肥城市学院普通专升本招生章程要求提供相关资料）"

        // },
    ]
}

//查看
export function showfreshgraduateDialogData() {
    return [
        {
            key: "stuNum",
            name: "考生号",
            value: '',
            type: 'text',
            isNull: true,
            writeOrRead: 'read'

        },
        {
            key: "name",
            name: "姓名",
            value: '',
            type: 'text',
            isNull: true,
            writeOrRead: 'read'

        }, {
            key: "sex",
            name: "性别",
            value: '男',
            type: 'text',
            isNull: true,
            writeOrRead: 'read'

        }, {
            key: "studyType",
            name: "科类",
            value: '',
            type: 'text',
            isNull: true,
            writeOrRead: 'read'

        }, {
            key: "idCard",
            name: "身份证号",
            value: '',
            type: 'text',
            isNull: true,
            writeOrRead: 'read'

        }, {
            key: "portfolioCategory",
            name: "投档段类",
            value: '',
            type: 'text',
            isNull: true,
            writeOrRead: 'read'

        }, {
            key: "readyProfession",
            name: "考试志愿",
            value: '',
            type: 'text',
            isNull: true,
            writeOrRead: 'read',
            options: [],
        },
        {
            key: "volunteerType",
            name: "志愿类别",
            value: '',
            type: 'text',
            isNull: true,
            writeOrRead: 'read'

        }, {
            key: "school",
            name: "毕业院校",
            value: '',
            type: 'text',
            isNull: true,
            writeOrRead: 'read'

        }, {
            key: "profession",
            name: "毕业专业",
            value: '',
            type: 'text',
            isNull: true,
            writeOrRead: 'read'

        },
        {
            key: "phone",
            name: "联系电话",
            value: '',
            type: 'text',
            isNull: true,
            writeOrRead: 'read'

        },
        {
            key: "contact",
            name: "紧急联系人",
            value: '',
            type: 'text',
            isNull: true,
            writeOrRead: 'read'

        }, {
            key: "address",
            name: "家庭住址",
            value: '',
            type: 'text',
            isNull: true,
            writeOrRead: 'read'

        },
        {
            key: "proveFile",
            name: "报名材料",
            fileName: '',
            uploadTitle: "报名材料",
            type: 'imgOrPdf',
            imgFlag: '',
            isNull: true,
            prompt: "",
            value: [],
            fujianload: '附件下载',
            url: "", // 附件url
            fujianName: "",
            nameflag: false,
            writeOrRead: 'read',
            prompt: "（注：仅支持图片及pdf格式）"
        },
        // {
        //     key: "statusCheckFile",
        //     name: "学籍资料审核表",
        //     fileName: '',
        //     uploadTitle: "学籍资料审核表",
        //     type: 'imgOrPdf',
        //     imgFlag: '',
        //     isNull: true,
        //     prompt: "(注:须加盖公章后上传)",
        //     value: [],
        //     fujianload: '附件下载',
        //     url: "", // 附件url
        //     nameflag: false,
        //     fujianName: "",
        //     writeOrRead: 'read'
        // },
        // {
        //     key: "withoutTestFile",
        //     name: "加分(免试)",
        //     fileName: '',
        //     uploadTitle: "加分(免试)",
        //     type: 'imgOrPdf',
        //     imgFlag: '',
        //     isNull: true,
        //     prompt: "",
        //     value: [],
        //     fujianload: '附件下载',
        //     url: "", // 附件url
        //     nameflag: false,
        //     fujianName: "",
        //     writeOrRead: 'read'
        // },
        // {
        //     key: "proveFile",
        //     name: "证明材料复印件",
        //     fileName: '',
        //     uploadTitle: "证明材料复印件",
        //     type: 'imgOrPdf',
        //     imgFlag: '',
        //     isNull: true,
        //     prompt: "",
        //     value: [],
        //     fujianload: '附件下载',
        //     url: "", // 附件url
        //     fujianName: "",
        //     nameflag: false,
        //     writeOrRead: 'read',
        //     prompt:"（注：按照2025年合肥城市学院普通专升本招生章程要求提供相关资料）"
        // },
    ]
}
